document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('slider-component').forEach(function (sliderComponent, index) {
    const thumbnailsSlider = sliderComponent.querySelector('.thumbnail-list.list-unstyled.slider');
    const prevButton = sliderComponent.querySelector('.slider-button--prev');
    const nextButton = sliderComponent.querySelector('.slider-button--next');
    
    if (!thumbnailsSlider || !prevButton || !nextButton) {
      return;
    }
    
    const liItems = thumbnailsSlider.querySelectorAll('li');
    if (!liItems.length) {
      return;
    }
    
    const step = parseInt(prevButton.getAttribute('data-step')) || 5;
    const itemWidth = liItems[0].offsetWidth;
    const scrollStep = itemWidth * step;
    
    // Détecter si on est sur mobile
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 768;
    
    function handleScroll(direction) {
      const currentScroll = thumbnailsSlider.scrollLeft;
      const scrollAmount = direction === 'prev' ? -scrollStep : scrollStep;
      const maxScroll = thumbnailsSlider.scrollWidth - thumbnailsSlider.clientWidth;
      
      let newScrollPosition = currentScroll + scrollAmount;
      if (newScrollPosition < 0) newScrollPosition = 0;
      if (newScrollPosition > maxScroll) newScrollPosition = maxScroll;
      
      thumbnailsSlider.scrollTo({
        left: newScrollPosition,
        behavior: 'smooth'
      });
    }
    
    // Fonction améliorée pour détecter la position des éléments
    function getVisibilityStatus(li) {
      const sliderRect = thumbnailsSlider.getBoundingClientRect();
      const liRect = li.getBoundingClientRect();
      
      // Marge plus importante sur mobile pour une meilleure détection
      const tolerance = isMobile ? 20 : 10;
      
      const isVisible = liRect.left >= sliderRect.left - tolerance && 
                       liRect.right <= sliderRect.right + tolerance;
      
      const isFirstVisible = liRect.left >= sliderRect.left - tolerance && 
                            liRect.left <= sliderRect.left + tolerance;
      
      const isLastVisible = liRect.right <= sliderRect.right + tolerance && 
                           liRect.right >= sliderRect.right - tolerance;
      
      // Détection spéciale pour mobile : vérifier si c'est le dernier élément visible
      const isAtRightEdge = Math.abs(liRect.right - sliderRect.right) <= tolerance;
      const isAtLeftEdge = Math.abs(liRect.left - sliderRect.left) <= tolerance;
      
      return {
        isVisible,
        isFirstVisible: isFirstVisible || isAtLeftEdge,
        isLastVisible: isLastVisible || isAtRightEdge
      };
    }
    
    prevButton.addEventListener('click', function (e) {
      e.preventDefault();
      handleScroll('prev');
    });
    
    nextButton.addEventListener('click', function (e) {
      e.preventDefault();
      handleScroll('next');
    });
    
    liItems.forEach((li, liIndex) => {
      li.addEventListener('click', (e) => {
        setTimeout(() => {
          const status = getVisibilityStatus(li);
          
          if (status.isLastVisible) {
            handleScroll('next');
          } else if (status.isFirstVisible) {
            handleScroll('prev');
          }
          
          const visibleItems = Array.from(liItems).filter(item => {
            const itemStatus = getVisibilityStatus(item);
            return itemStatus.isVisible;
          });
          
          const isLastInVisibleGroup = visibleItems.length > 0 && 
                                      visibleItems[visibleItems.length - 1] === li;
          const isFirstInVisibleGroup = visibleItems.length > 0 && 
                                       visibleItems[0] === li;
          
          if (isMobile && !status.isLastVisible && !status.isFirstVisible) {
            if (isLastInVisibleGroup && liIndex < liItems.length - 1) {
              handleScroll('next');
            } else if (isFirstInVisibleGroup && liIndex > 0) {
              handleScroll('prev');
            }
          }
        }, 50);
      });
    });
    
    // Styles pour le slider
    thumbnailsSlider.style.display = 'flex';
    thumbnailsSlider.style.overflowX = 'auto';
    thumbnailsSlider.style.scrollBehavior = 'smooth';
    thumbnailsSlider.style.webkitOverflowScrolling = 'touch';
    thumbnailsSlider.style.scrollbarWidth = 'none';
    thumbnailsSlider.style.msOverflowStyle = 'none';
    
    liItems.forEach(li => {
      li.style.flex = '0 0 auto';
    });
    
    // Cacher la scrollbar
    const style = document.createElement('style');
    style.textContent = `
      slider-component .thumbnail-list::-webkit-scrollbar {
        display: none;
      }
    `;
    document.head.appendChild(style);
  });
});